module.exports = __webpack_public_path__ + "img/js.18c96949.png";